import { useQuery } from "@tanstack/react-query";
import { getCompleteStopByPositionID } from "../../../services/cdkOrderService";

const useGetCompleteStopDetail = (positionId) => {
  const query = useQuery({
    queryKey: ["completeStopDetail", positionId],
    queryFn: () => getCompleteStopByPositionID(positionId),
    enabled: Boolean(positionId), // Only run the query if positionId is provided
  });

  return query;
};

export default useGetCompleteStopDetail;
